import styled from "styled-components";

export const Container = styled.div`
  .headder-container {
    width: 90%;
    margin: auto;
    overflow-x: hidden;
    &.exporting {
      opacity: 0.5;
    }
    .headder-options-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 2rem 0;
    }
    .headder-teams-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .option-content {
        width: 40%;
      }
    }
    .option-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 33%;
      label {
        color: #6f7a80;
        font-weight: 700;
      }
      select {
        margin: 1rem 0;
        border: 1px solid #ccc;
        width: 70%;
        color: #333;
        font-size: 1em;
        height: 36px;
        -webkit-appearance: none;
        border-radius: 1.5rem;
      }
      #date-pop-up {
        display: none;
        position: fixed;
        background: #fff;
        width: 80vw;
        height: 40vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid black;
        &.active {
          display: block;
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .headder-container .option-content #date-pop-up {
      width: 400px;
      height: 400px;
    }
  }
`;
